import { FieldSlugEnum } from 'common/enums/FieldSlugEnum'
import { IdentificationTypeEnum } from 'common/enums/PaymentMethodEnum'
import { changeField } from 'publisher/actions/optInActions'
import { useMercadoPago } from 'publisher/context/mercadoPagoContext'
import {
  CustomTaxNumberOptionsKeys,
  customTaxNumberOptions,
} from 'publisher/pages/offer-page/constants/custom-tax-number-options'
import {
  getCleanIdentificationNumberValue,
  getCleanRUTValue,
} from 'publisher/pages/offer-page/utils/getCleanIdentificationNumberValue'
import { useOptIn } from 'publisher/store'
import {
  getFieldErrorsBySlug,
  getFieldValueBySlug,
} from 'publisher/store/optIn/optInSelectors'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

export function useCustomTaxNumber(type: CustomTaxNumberOptionsKeys) {
  const dispatch = useDispatch()
  const { errors } = useMercadoPago()
  const value = useOptIn(optIn =>
    getFieldValueBySlug(optIn, FieldSlugEnum.TaxNumber),
  )
  const optInErrors = useOptIn(optIn =>
    getFieldErrorsBySlug(optIn, FieldSlugEnum.TaxNumber),
  )
  const [error, setError] = useState('')
  const [identificationType, setIdentificationType] =
    useState<IdentificationTypeEnum>(
      customTaxNumberOptions[type].personalIdentificationType,
    )

  useEffect(() => {
    if (value) {
      setIdentificationType(
        customTaxNumberOptions[type].detectIdentificationType(value),
      )
    }
  }, [value])

  useEffect(() => {
    if (errors.identificationNumber) {
      setError(errors.identificationNumber)
    }
  }, [errors])

  function resetError() {
    setError('')
  }

  function change(value: string) {
    setIdentificationType(
      customTaxNumberOptions[type].detectIdentificationType(value),
    )

    dispatch(changeField(FieldSlugEnum.TaxNumber, value))
    if (error) {
      resetError()
    }
  }

  const transform =
    identificationType === IdentificationTypeEnum.RUT
      ? getCleanRUTValue
      : getCleanIdentificationNumberValue

  return {
    change,
    transform,
    value,
    errors: optInErrors.length > 0 ? optInErrors : error ? [error] : [],
    identificationType,
  }
}
